var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.247 4.34a.844.844 0 0 1 1.193 0l4.782 4.782c.33.33.33.864 0 1.193l-4.782 4.782a.844.844 0 0 1-1.193-1.194l3.34-3.34H5.22a.844.844 0 0 1 0-1.688h8.369l-3.341-3.34a.844.844 0 0 1 0-1.194"
  })));
};
export default SvgArrowRight;